import { useState } from "react";

const VIDEO_ID = "6AV3Pj9Da2Y";

export default function VslSection() {
  const [playing, setPlaying] = useState(false);

  return (
    <section className="relative z-10 px-6 md:px-12 pt-4 md:pt-8">
      <div className="max-w-4xl mx-auto">
        <div
          className="relative aspect-video overflow-hidden rounded-3xl border border-white/10"
          style={{ boxShadow: "0 24px 64px rgba(0,0,0,0.55)" }}
        >
          {playing ? (
            <iframe
              className="absolute inset-0 h-full w-full"
              src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1`}
              title="Dr. Weedy em ação"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <button
              type="button"
              onClick={() => setPlaying(true)}
              className="group absolute inset-0 h-full w-full"
              aria-label="Assistir ao vídeo"
            >
              <img
                src={`https://img.youtube.com/vi/${VIDEO_ID}/maxresdefault.jpg`}
                alt=""
                loading="lazy"
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/10 to-black/50 transition-colors group-hover:to-black/60" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div
                  className="flex items-center justify-center rounded-full transition-transform group-hover:scale-105"
                  style={{
                    width: 88,
                    height: 88,
                    background: "linear-gradient(135deg, #FF8904 0%, #E7000B 100%)",
                    boxShadow: "0 10px 34px rgba(255, 137, 4, 0.55)",
                    border: "3px solid rgba(255,255,255,0.25)",
                  }}
                >
                  <svg width="30" height="34" viewBox="0 0 30 34" fill="none">
                    <path d="M2 2 L28 17 L2 32 Z" fill="#ffffff" />
                  </svg>
                </div>
              </div>
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
